// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import config from './utils/config'
import language from './utils/language'
import top from './components/top'
import foot from './components/foot'
import activeOne from './components/activeOne'
import addressOne from './components/addressOne'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(ViewUI);

Vue.component('top', top)
Vue.component('foot', foot)
Vue.component('activeOne', activeOne)
Vue.component('addressOne', addressOne)

Vue.config.productionTip = false
Vue.$config = Vue.prototype.$config = config
Vue.$language = Vue.prototype.$language = language

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js